/* Danish interface text, keyed by the English source exactly as the code
 * passes it to t() / uiText(). One file per area of the app; a key lives in
 * one file only (test/translations.test.ts checks). Wording follows
 * qorpera.com. */
/** The frame: rail, hub, new conversation, sign-in, approvals, computer, dialogs. */
export const WORKSPACE: Record<string, string> = {
	// app/application.ts
	"Company navigation": "Virksomhedsnavigation",
	"Close company navigation": "Luk virksomhedsnavigation",
	"Company access is unavailable.": "Adgang til virksomheden er ikke tilgængelig.",
	"The conversation destination changed. Refresh before sending.":
		"Samtalens modtager er ændret. Opdater, før du sender.",
	"This agent is not available in the company.": "Denne agent er ikke tilgængelig i virksomheden.",
	"Connecting to the cloud": "Forbinder til skyen",
	// app/new-version.ts
	"A new version is available.": "Der er en ny version.",
	Reload: "Genindlæs",
	"Text you have not sent will be lost. Reload anyway?": "Tekst, du ikke har sendt, går tabt. Genindlæs alligevel?",
	"This company is not available to your account.": "Denne virksomhed er ikke tilgængelig for din konto.",
	"Back to companies": "Tilbage til virksomheder",
	"Your access to this company was revoked.": "Din adgang til denne virksomhed er blevet fjernet.",
	"Company notification access changed.": "Adgangen til virksomhedens notifikationer er ændret.",
	"Only an owner or admin can change agents.": "Kun en ejer eller administrator kan ændre agenter.",
	"Company access changed.": "Adgangen til virksomheden er ændret.",
	"Conversation access changed.": "Adgangen til samtalen er ændret.",
	"Only an owner or admin can create a group chat.": "Kun en ejer eller administrator kan oprette en gruppechat.",
	"Group chat creation access changed.": "Adgangen til at oprette gruppechats er ændret.",
	"Opening company": "Åbner virksomhed",
	"Opening the Co-Founder": "Åbner Co-Founder",
	"Start with {agent} or pick a conversation in the rail.": "Start med {agent}, eller vælg en samtale i sidepanelet.",
	"This company has no staff conversations yet.": "Denne virksomhed har ingen samtaler med agenter endnu.",
	"Only an owner or admin can edit group chats.": "Kun en ejer eller administrator kan redigere gruppechats.",
	"Group chat editing access changed.": "Adgangen til at redigere gruppechats er ændret.",
	"Attachment access changed.": "Adgangen til den vedhæftede fil er ændret.",
	"This attachment is not available for preview.": "Denne vedhæftede fil kan ikke vises.",
	"Opening conversation": "Åbner samtale",
	"Company File access changed.": "Adgangen til Virksomhedsfilen er ændret.",

	// app/auth.ts
	"Sign-in could not be completed. Request a new email code in this browser.":
		"Du kunne ikke logges ind. Bed om en ny kode på e-mail i denne browser.",
	"Enter a valid email address.": "Skriv en gyldig e-mailadresse.",
	"Check your email. Enter the code below, or open the sign-in link on this device.":
		"Tjek din e-mail. Skriv koden herunder, eller åbn login-linket på denne enhed.",
	"This sign-in provider is unavailable. Continue with email.":
		"Denne loginmetode er ikke tilgængelig. Fortsæt med e-mail.",
	"You were signed out. Sign in again.": "Du er blevet logget ud. Log ind igen.",
	Member: "Medlem",

	// app/start-conversation.ts
	"Wait for this conversation to finish opening.": "Vent, til samtalen er åbnet.",
	"You do not have permission to send messages in this company.":
		"Du har ikke tilladelse til at sende beskeder i denne virksomhed.",
	"Choose active agents from this company before sending.": "Vælg aktive agenter fra denne virksomhed, før du sender.",
	"Enter a message of no more than 64 KiB.": "Skriv en besked på højst 64 KiB.",
	"Connect a model account in Settings → AI subscriptions to send messages.":
		"Forbind en modelkonto i Indstillinger → AI-abonnementer for at sende beskeder.",
	"The group chat could not be created. Your message is still here.":
		"Gruppechatten kunne ikke oprettes. Din besked er her stadig.",
	"The group chat is still opening. Send again to retry the same conversation.":
		"Gruppechatten åbner stadig. Send igen for at prøve den samme samtale igen.",
	"No model account is currently available. Try again after an account resets.":
		"Ingen modelkonto er ledig lige nu. Prøv igen, når en konto nulstilles.",
	"Open the existing conversation to finish its pending message before sending another.":
		"Åbn den eksisterende samtale, og gør dens ventende besked færdig, før du sender en ny.",
	"This conversation has an unsent draft. Open it to finish or clear that draft before sending another.":
		"Denne samtale har en usendt kladde. Åbn den, og gør kladden færdig eller ryd den, før du sender en ny.",

	// app/views/shell.ts: the Agents | Interfaces switch and the Interfaces tab
	Interfaces: "Interfaces",
	"Agents or interfaces": "Agenter eller interfaces",
	"No matching interfaces.": "Ingen interfaces passer.",
	"Search interfaces": "Søg i interfaces",
	"Close search": "Luk søgning",
	Views: "Visninger",
	Kind: "Slags",
	Due: "Frist",
	What: "Hvad",
	Since: "Siden",
	"Unfinished run": "Ufærdig kørsel",
	Mention: "Omtale",
	Task: "Opgave",
	Offer: "Tilbud",
	Yes: "Ja",
	No: "Nej",
	Actions: "Handlinger",
	Filter: "Filtrér",
	"Filter {title}": "Filtrér {title}",
	"No rows match.": "Ingen rækker passer.",
	"Choose one to see it here.": "Vælg en for at se den her.",
	"This row's email can't be quoted in a message.": "Mailen i denne række kan ikke citeres i en besked.",
	"The Co-Founder's thread can't be opened here.": "Co-Founderens tråd kan ikke åbnes her.",

	// app/interfaces.ts and app/views/interface.ts
	"{name} needs you": "{name} har brug for dig",
	"{name} has a run that did not finish": "{name} har en kørsel, der ikke blev færdig",
	"You were mentioned in {conversation}": "Du blev nævnt i {conversation}",
	"This page isn't available here yet.": "Siden er ikke tilgængelig her endnu.",
	"Back to the company": "Tilbage til virksomheden",
	Live: "Live",
	"Nothing here right now.": "Intet her lige nu.",
	// Tables read from the company folder (app/interfaces.ts, app/views/interface.ts)
	"Line {line}: {problem}": "Linje {line}: {problem}",
	"Some rows can't be shown.": "Nogle rækker kan ikke vises.",
	"This table can't be read.": "Tabellen kan ikke læses.",
	// The folder sources and the text, numbers and calendar blocks (app/interface-sources.ts,
	// app/views/interface-blocks.ts, app/views/interface.ts)
	"This can't be read right now.": "Det kan ikke læses lige nu.",
	Figure: "Figur",
	Colour: "Farve",
	Status: "Status",
	People: "Personer",
	"Requested by": "Bedt om af",
	Service: "Tjeneste",
	Organization: "Organisation",
	Person: "Person",
	About: "Om",
	Emblem: "Emblem",
	Text: "Tekst",
	Routine: "Rutine",
	"To do": "Skal gøres",
	Active: "Aktiv",
	Concluded: "Afsluttet",
	Blocked: "Blokeret",
	Archived: "Arkiveret",
	Accepted: "Godkendt",
	Returned: "Sendt tilbage",
	Broken: "Virker ikke",
	Pending: "Afventer",
	"Needs a person": "Kræver en person",
	Off: "Slået fra",
	"Target {value}": "Mål {value}",
	"{change} since {time}": "{change} siden {time}",
	"No change since {time}": "Ingen ændring siden {time}",
	"No change": "Ingen ændring",
	"Trend over {weeks} weeks": "Udvikling over {weeks} uger",
	Today: "I dag",
	Tomorrow: "I morgen",
	// A board and the members source (app/interface-board.ts, app/interface-claims.ts, app/views/interface.ts)
	Shared: "Fælles",
	"Open pile": "Åben bunke",
	"Someone who left": "En, der er stoppet",
	"{name} (left)": "{name} (stoppet)",
	"Nothing here.": "Intet her.",
	Take: "Tag",
	Release: "Slip",
	"The card could not be taken.": "Kortet kunne ikke tages.",
	"The card could not be released.": "Kortet kunne ikke slippes.",
	"This card is no longer here.": "Kortet er her ikke længere.",
	"Someone else took it first.": "En anden tog det først.",
	"That changed while you were looking.": "Det blev ændret, mens du kiggede.",
	// Offers of a card (app/interface-claims.ts, app/interfaces.ts, app/views/interface.ts, step I9c)
	"Offer…": "Tilbyd…",
	"Offer to": "Tilbyd til",
	"Offered to {name}": "Tilbudt til {name}",
	"{name} offers it to you": "{name} tilbyder dig det",
	"{from} offered it to {to}": "{from} tilbød det til {to}",
	"{name} offers you “{row}” in {table}": "{name} tilbyder dig “{row}” i {table}",
	"The offer could not be accepted.": "Tilbuddet kunne ikke accepteres.",
	// An area's supervision (app/views/interface.ts, step I9b)
	"Supervise its agents too?": "Vil du også have tilsyn med dets agenter?",
	Supervise: "Før tilsyn",
	"Nobody supervises its agents.": "Ingen har tilsyn med dets agenter.",
	"You supervise its agents.": "Du har tilsyn med dets agenter.",
	"Waiting for your yes to supervise its agents.": "Venter på dit ja til at have tilsyn med dets agenter.",
	"Waiting for {name}'s yes to supervise its agents.": "Venter på {name}s ja til at have tilsyn med dets agenter.",
	"The supervisor could not be changed.": "Tilsynet kunne ikke ændres.",
	// An area added and its agents (app/interface-areas.ts, app/views/interface.ts, Interfaces C6d)
	"No areas yet.": "Ingen områder endnu.",
	"Add an area": "Tilføj et område",
	"An area needs a name.": "Et område skal have et navn.",
	"There is already an area called {area}.": "Der er allerede et område, der hedder {area}.",
	"The area could not be added.": "Området kunne ikke tilføjes.",
	"The areas are no longer here.": "Områderne er her ikke længere.",
	"Add an agent": "Tilføj en agent",
	"Every agent is in an area already.": "Alle agenter er allerede i et område.",
	"Only {name}, who supervises its agents, adds agents.":
		"Kun {name}, der har tilsyn med dets agenter, tilføjer agenter.",
	"That agent": "Den agent",
	"That agent is in another area now.": "Den agent er i et andet område nu.",
	"{name} is already in another area.": "{name} er allerede i et andet område.",
	"Only the area's supervisor adds its agents now.": "Nu tilføjer kun den, der har tilsyn med området, dets agenter.",
	"The area's agents could not be changed.": "Områdets agenter kunne ikke ændres.",
	"This area is no longer here.": "Området er her ikke længere.",
	Picture: "Billede",
	Role: "Rolle",
	"Here now": "Her nu",
	// The Mailbox and the mail sources (app/views/interface-mail.ts, app/views/interface.ts, app/views/shell.ts)
	"From outside the company": "Fra uden for virksomheden",
	Unread: "Ulæst",
	"Unknown sender": "Ukendt afsender",
	"Account mail": "Kontomail",
	"Account mail (unknown account)": "Kontomail (ukendt konto)",
	"Reading the mail": "Læser posten",
	"The mail can't be read right now.": "Posten kan ikke læses lige nu.",
	"Older mail can't be read.": "Ældre post kan ikke læses.",
	"Reading older mail": "Læser ældre post",
	"(no subject)": "(intet emne)",
	"Handled by {name}": "Håndteres af {name}",
	"Reading the email": "Læser e-mailen",
	"This email thread is no longer here.": "Denne e-mailtråd er her ikke længere.",
	"Show older messages": "Vis ældre beskeder",
	"Reading older messages": "Læser ældre beskeder",
	"Older messages can't be read.": "Ældre beskeder kan ikke læses.",
	"last used by {agent} {time}": "sidst brugt af {agent} {time}",
	"last used by {agent}": "sidst brugt af {agent}",
	"last used {time}": "sidst brugt {time}",
	"Not sent": "Ikke sendt",
	"Automated email": "Automatisk e-mail",
	"This email is longer; only its start is shown.": "Denne e-mail er længere; kun starten vises.",
	"This email's text is no longer kept.": "Denne e-mails tekst gemmes ikke længere.",
	Attachments: "Vedhæftede filer",
	"{name} wants to send this email": "{name} vil sende denne e-mail",
	"This send waits for someone who can answer it.": "Denne afsendelse venter på en, der kan svare på den.",
	"This answer needs your model account. Answer it in {name}'s thread, where you can choose one.":
		"Dette svar kræver din modelkonto. Svar i tråden med {name}, hvor du kan vælge en.",
	"Open {name}'s thread": "Åbn tråden med {name}",
	Thread: "Tråd",
	Address: "Adresse",
	"From address": "Fra-adresse",
	"Last message": "Seneste besked",
	State: "Status",
	"Handled by": "Håndteres af",
	Direction: "Retning",
	"Last 7 days": "Seneste 7 dage",
	New: "Ny",
	Handled: "Håndteret",
	Waiting: "Venter",
	Received: "Modtaget",
	"{count} waiting": "{count} venter",
	// The Mailbox page (app/views/mailbox.ts, app/company-mail.ts)
	Inbox: "Indbakke",
	Addresses: "Adresser",
	"Search mail": "Søg i posten",
	Search: "Søg",
	Write: "Skriv",
	"The company has no email address yet": "Virksomheden har ingen e-mailadresse endnu",
	"Make one, and pick the agent who answers what comes in.":
		"Lav en, og vælg den agent, der svarer på det, der kommer ind.",
	"Make an address": "Lav en adresse",
	// Digital Post in the Mailbox (app/views/mailbox.ts)
	"Letters from public authorities come here too, once Digital Post is connected in Settings.":
		"Breve fra offentlige myndigheder kommer også her, når Digital Post er forbundet under Indstillinger.",
	"No Digital Post yet": "Ingen Digital Post endnu",
	"Letters from public authorities come here as Digital Post delivers them.":
		"Breve fra offentlige myndigheder kommer her, efterhånden som Digital Post leverer dem.",
	"Legal effect": "Retsvirkning",
	"Digital Post": "Digital Post",
	"Mandatory post": "Obligatorisk post",
	"Reply by {when}": "Svar senest {when}",
	"Case {id}": "Sag {id}",
	"Reading the letter": "Læser brevet",
	"This letter is no longer in the company folder.": "Brevet ligger ikke længere i virksomhedens mappe.",
	"This letter is too long to show here. Open its folder to read it and its documents.":
		"Brevet er for langt til at blive vist her. Åbn dets mappe for at læse det og dets dokumenter.",
	"The letter's text is in its documents.": "Brevets tekst står i dets dokumenter.",
	"Open the letter's folder": "Åbn brevets mappe",
	"Tell {name} what to do with this letter": "Fortæl {name}, hvad der skal ske med brevet",
	"About the Digital Post letter {id} (its folder in {folder} ends with its id): ":
		"Om Digital Post-brevet {id} (dets mappe i {folder} slutter med dets id): ",
	"Who the note goes to": "Hvem beskeden går til",
	"Not connected": "Ikke forbundet",
	"Digital Post refused the key": "Digital Post afviste nøglen",
	"Not reached at the last try": "Kunne ikke nås ved sidste forsøg",
	"Checked {when}": "Tjekket {when}",
	"Letters from public authorities": "Breve fra offentlige myndigheder",
	letters: "breve",
	letter: "brev",
	"Choose who reads it": "Vælg, hvem der læser den",
	"Who should read it?": "Hvem skal læse den?",
	"Please have {name} read the company's Digital Post: a routine that wakes on new letters in digital-post/ (a file change, the whole folder), reads each letter's letter.md and acts on it.":
		"Lad {name} læse virksomhedens Digital Post: en rutine, der vågner ved nye breve i digital-post/ (en filændring, hele mappen), læser hvert brevs letter.md og handler på det.",
	"Asked {cofounder} to have {name} read Digital Post": "Bad {cofounder} om at lade {name} læse Digital Post",
	"No mail matches.": "Ingen post passer.",
	"Nothing has been sent yet.": "Der er ikke sendt noget endnu.",
	"Everything else": "Alt andet",
	"{address} is ready": "{address} er klar",
	"No mail yet": "Ingen post endnu",
	"Nothing has arrived yet. {name} answers what comes in.":
		"Der er ikke kommet noget endnu. {name} svarer på det, der kommer ind.",
	"Nothing has arrived yet.": "Der er ikke kommet noget endnu.",
	"unknown account": "ukendt konto",
	"{name} used the account": "{name} brugte kontoen",
	"{name} hasn't handled it yet": "{name} har ikke taget sig af den endnu",
	"{name} handles it": "{name} tager sig af den",
	"{name} wants to send this": "{name} vil sende denne",
	"Back to Sent": "Tilbage til Sendt",
	"Back to Inbox": "Tilbage til Indbakke",
	outside: "udefra",
	"to {who}": "til {who}",
	"cc {who}": "cc {who}",
	"Not known who used the account": "Det vides ikke, hvem der brugte kontoen",
	"Tell {name} what to answer": "Fortæl {name}, hvad der skal svares",
	"About the email {subject} from {from_name}: ": "Om e-mailen {subject} fra {from_name}: ",
	"{name} has your note": "{name} har fået din besked",
	"Send to {name}": "Send til {name}",
	"{name} answers it": "{name} svarer på den",
	"No agent answers it yet": "Ingen agent svarer på den endnu",
	"in the last 7 days": "de seneste 7 dage",
	Change: "Skift",
	"Who should answer it?": "Hvem skal svare på den?",
	"Please have {name} answer the email that comes to {address}.":
		"Lad venligst {name} svare på de e-mails, der kommer til {address}.",
	"Asked {cofounder} to give {address} to {name}": "Bad {cofounder} om at give {address} til {name}",
	"New address": "Ny adresse",
	"Please write an email to {to} from {from}: {words}": "Skriv venligst en e-mail til {to} fra {from}: {words}",
	"Please write an email to {to}: {words}": "Skriv venligst en e-mail til {to}: {words}",
	"{name} is writing it": "{name} skriver den",
	"Who writes it": "Hvem skriver den",
	Writer: "Skribent",
	"from {address}": "fra {address}",
	"Name or email address": "Navn eller e-mailadresse",
	"What should it say": "Hvad skal der stå",
	"What should it say?": "Hvad skal der stå?",
	"Ask {name} to write it": "Bed {name} om at skrive den",
	"{name} writes and sends it": "{name} skriver og sender den",
	"That agent is no longer at work.": "Den agent er ikke længere på arbejde.",

	// app/views/shell.ts
	"Profile: {name}": "Profil: {name}",
	"← Companies": "← Virksomheder",
	"Search agents": "Søg efter agenter",
	"New conversation or agent": "Ny samtale eller agent",
	company: "virksomhed",
	"No matching conversations.": "Ingen samtaler matcher.",
	"No agents yet.": "Ingen agenter endnu.",
	"Retry conversations": "Hent samtaler igen",
	"Retry company": "Hent virksomhed igen",
	connecting: "forbinder",
	"live updates degraded": "liveopdateringer virker ikke helt",

	// app/views/hub.ts
	founder: "stifter",
	admin: "administrator",
	contributor: "bidragyder",
	viewer: "læser",
	"Resume the pending company creation before starting another.":
		"Gør oprettelsen af den ventende virksomhed færdig, før du starter en ny.",
	"Creating a company is paused. Try again later.": "Det er sat på pause at oprette virksomheder. Prøv igen senere.",
	"Invited as {role} · expires {date}": "Inviteret som {role} · udløber {date}",
	Accept: "Accepter",
	"Company name": "Virksomhedsnavn",
	or: "eller",
	"Resume creating {name}": "Genoptag oprettelsen af {name}",
	"New company": "Ny virksomhed",
	Create: "Opret",
	"Loading companies": "Henter virksomheder",

	// app/views/new-conversation.ts
	"Selected recipients": "Valgte modtagere",
	"Message…": "Besked…",
	"Send message": "Send besked",
	"Search or create agents": "Søg efter eller opret agenter",
	"Search conversation recipients": "Søg efter modtagere til samtalen",
	"To:": "Til:",
	"Close new conversation": "Luk ny samtale",
	"New agent “{name}”": "Ny agent “{name}”",
	"New group chat": "Ny gruppechat",
	"Add agents": "Tilføj agenter",
	"No agents match.": "Ingen agenter matcher.",
	"Remove {name}": "Fjern {name}",
	"Starting conversation…": "Starter samtale…",
	"The conversation could not be started. Your draft is still here.":
		"Samtalen kunne ikke startes. Din kladde er her stadig.",
	"Agent name": "Agentnavn",
	"For example, Research": "For eksempel Forskning",
	"Agent title": "Agentens titel",
	"What should this agent be responsible for?": "Hvad skal denne agent have ansvar for?",
	"Agent responsibilities": "Agentens ansvarsområder",
	Name: "Navn",
	Title: "Titel",
	Responsibilities: "Ansvarsområder",
	"The agent was created. Retry adding it once the agent list is available.":
		"Agenten blev oprettet. Prøv at tilføje den igen, når listen over agenter er klar.",
	"Agent creation is not available yet.": "Oprettelse af agenter er ikke tilgængelig endnu.",
	"Add created agent": "Tilføj den oprettede agent",
	"Create agent": "Opret agent",
	"Create an agent": "Opret en agent",
	"Enter a name and title.": "Skriv et navn og en titel.",
	"Creating agent…": "Opretter agent…",
	"Creation could not be confirmed. Retry to check the same agent.":
		"Oprettelsen kunne ikke bekræftes. Prøv igen for at kontrollere den samme agent.",
	"Check agent creation": "Kontroller agentoprettelse",
	"Agent creation was rejected. Your draft is still here and can be edited.":
		"Agentoprettelsen blev afvist. Din kladde er her stadig og kan redigeres.",
	"Agent details are too long or invalid. Shorten them and try again.":
		"Agentoplysningerne er for lange eller ugyldige. Gør dem kortere, og prøv igen.",

	// app/views/signin.ts
	"Continue with {provider}": "Fortsæt med {provider}",
	"you@company.com": "dig@firma.dk",
	"Code from your email": "Kode fra din e-mail",
	"Verification code": "Bekræftelseskode",
	Email: "E-mail",
	"We sent a code to {email}. Enter it here; the link in the same email works only in this browser.":
		"Vi har sendt en kode til {email}. Skriv den her; linket i samme e-mail virker kun i denne browser.",
	"Verify and sign in": "Bekræft og log ind",
	"Continue with email": "Fortsæt med e-mail",
	"Use a different email": "Brug en anden e-mail",
	"One moment…": "Et øjeblik…",
	"Sign in": "Log ind",
	"Your companies and agents, in one place.": "Dine virksomheder og agenter samlet ét sted.",
	"Only your own session lives in this browser; agents run in the cloud.":
		"Kun din egen session ligger i denne browser; agenter kører i skyen.",

	// app/views/approvals.ts

	// app/views/meet.ts
	"This company has no Co-Founder yet. The cloud seeds one when Order 0 bootstraps the company; until then there is no agent to dress.":
		"Denne virksomhed har ingen Co-Founder endnu. Skyen opretter en, når Order 0 starter virksomheden; indtil da er der ingen agent at give et udseende.",
	"Open the company": "Åbn virksomheden",
	"Your journey starts here": "Din rejse starter her",
	"Choose a figure": "Vælg en figur",
	"Saving…": "Gemmer…",
	"Save appearance and continue": "Gem udseende og fortsæt",
	"The appearance change could not be confirmed. Open the company to check it before saving again.":
		"Ændringen af udseendet kunne ikke bekræftes. Åbn virksomheden og tjek det, før du gemmer igen.",
	"Open the company without changing appearance": "Åbn virksomheden uden at ændre udseende",

	// app/views/computer.ts
	"Connecting…": "Forbinder…",
	"Close computer": "Luk computer",
	"{name} · Computer": "{name} · Computer",
	"{name} · Computer · Machine {number}": "{name} · Computer · Maskine {number}",
	"Agent computer": "Agentens computer",
	"Drag to move, drag an edge to resize. When focused, arrow keys move it and plus or minus resize it.":
		"Træk for at flytte, træk i en kant for at ændre størrelse. Med fokus flytter piletasterne den, og plus eller minus ændrer størrelsen.",
	"Computer access is not available yet.": "Adgang til computeren er ikke tilgængelig endnu.",
	"This company has no machine yet.": "Denne virksomhed har ingen maskine endnu.",
	"The machine is restarting. It comes back on its own.": "Maskinen genstarter. Den kommer tilbage af sig selv.",
	"This machine has been retired.": "Denne maskine er taget ud af brug.",
	"The machine is off. An owner or admin can start it.":
		"Maskinen er slukket. En ejer eller administrator kan starte den.",
	"You have read-only access. A company member with write access can wake the machine.":
		"Du har kun læseadgang. Et medlem af virksomheden med skriveadgang kan vække maskinen.",
	"Starting the machine…": "Starter maskinen…",
	"Computer viewing is not set up here.": "Computervisning er ikke sat op her.",
	"All computers on this machine are in use. Try again when one is free.":
		"Alle computere på denne maskine er i brug. Prøv igen, når en er ledig.",
	"{name} does not have access to the computer.": "{name} har ikke adgang til computeren.",
	"{name}'s computer is being handed over. It opens here in a moment.":
		"Computeren for {name} bliver overdraget. Den åbner her om et øjeblik.",
	"The machine is not ready yet.": "Maskinen er ikke klar endnu.",
	"The machine is private right now. Shared viewing returns when that ends.":
		"Maskinen er privat lige nu. Delt visning kommer tilbage, når det slutter.",
	"The computer could not be reached. Try again.": "Computeren kunne ikke nås. Prøv igen.",
	"The computer screen could not be loaded in this tab. Reload the page to open it.":
		"Computerskærmen kunne ikke indlæses i denne fane. Genindlæs siden for at åbne den.",
	"Reload page": "Genindlæs siden",
	"All computers are in use. An owner or admin can start another machine.":
		"Alle computere er i brug. En ejer eller administrator kan starte en maskine mere.",
	"Setting up another machine. This can take a while.": "Sætter en maskine mere op. Det kan tage et stykke tid.",
	"Setting up the machine. This can take a while.": "Sætter maskinen op. Det kan tage et stykke tid.",
	"Waiting for room on our servers. It starts as soon as there is room.":
		"Venter på plads på vores servere. Den starter, så snart der er plads.",
	"Out of computer hours. The machine starts by itself once hours are added.":
		"Ingen computertimer tilbage. Maskinen starter af sig selv, når der er tilføjet timer.",

	// app/views/feedback.ts
	"+ Bug": "+ Fejl",
	"+ Bad result": "+ Dårligt resultat",
	"+ Good result": "+ Godt resultat",
	"+ Feature request": "+ Funktionsønske",
	"+ Performance": "+ Ydeevne",
	"+ Other": "+ Andet",
	"Feedback details": "Feedbackdetaljer",
	"Share details (required)": "Del detaljer (påkrævet)",
	Submit: "Send",
	"Feedback category": "Feedbackkategori",
	"Close feedback": "Luk feedback",
	"Sending…": "Sender…",
	"Feedback sent. Thank you.": "Feedback sendt. Tak.",

	// ui/dom.ts, ui/dialog.ts, ui/rail-layout.ts
	Loading: "Henter",
	"Type {name} to confirm": "Skriv {name} for at bekræfte",
	"Close {name}": "Luk {name}",
	"Resize company navigation": "Tilpas bredden på virksomhedsnavigationen",
	Compact: "Kompakt",
	"{width} pixels": "{width} pixel",

	// ui/avatar.ts, ui/figure-picker.ts: figure names are the figure ids.
	"Agent figure": "Agentfigur",
	"Agent color": "Agentfarve",
	planet: "planet",
	acorn: "agern",
	flame: "flamme",
	rocket: "raket",
	crown: "krone",
	heart: "hjerte",
	ghost: "spøgelse",
	Charcoal: "Koksgrå",
	Brown: "Brun",
	Coral: "Koral",
	Orange: "Orange",
	Gold: "Guld",
	Teal: "Blågrøn",
	Purple: "Lilla",
	Pink: "Pink",
	Gray: "Grå",
	// ui/computer-viewer.ts: the desktop's screen viewer, translated where it shows
	"Back to thread": "Tilbage til tråden",
	"Checking your private sign-in access": "Tjekker din private login-adgang",
	"Close screen viewer": "Luk skærmen",
	"Cloud screen unavailable. Reconnect to check access again.":
		"Skærmen er ikke tilgængelig. Forbind igen for at tjekke adgangen.",
	"Connecting to cloud desktop": "Forbinder til computeren",
	Connecting: "Forbinder",
	Disconnected: "Afbrudt",
	Enter: "Gå ind",
	"Full screen unavailable": "Fuld skærm er ikke tilgængelig",
	"Private sign-in · Closing this view leaves the office private":
		"Privat login · Lukker du visningen, forbliver kontoret privat",
	Reconnect: "Forbind igen",
	"Release control": "Giv kontrollen tilbage",
	"Shared with the agent": "Delt med agenten",
	"Starting the screen and connecting…": "Starter skærmen og forbinder…",
	"Take control": "Overtag",
	"Waiting for the cloud screen to release agent control": "Venter på, at agenten slipper kontrollen",
	"Watching only": "Ser kun med",
	"You control this cloud screen": "Du styrer skærmen",
	"Opening Company File": "Åbner Virksomhedsfilen",
	"Your membership in this company could not be read.": "Dit medlemskab af virksomheden kunne ikke læses.",
	"The cloud could not be reached. {error}": "Skyen kunne ikke nås. {error}",
	"Loading agents": "Henter agenter",
	// app/views/shell.ts: sections, pins and the right-click menu
	"Only owners, admins and contributors can change the company's sections.":
		"Kun ejere, administratorer og bidragydere kan ændre virksomhedens sektioner.",
	"The sidebar could not be changed. Try again.": "Sidepanelet kunne ikke ændres. Prøv igen.",
	"This section is no longer there.": "Sektionen findes ikke længere.",
	"The Co-Founder stays on top, above the sections.": "Co-Founderen står øverst, over sektionerne.",
	"This company has no sections file.": "Virksomheden har ingen sektionsfil.",
	"The company's sections file does not read as sections. Ask the Co-Founder to correct {path}.":
		"Virksomhedens sektionsfil kan ikke læses som sektioner. Bed Co-Founderen om at rette {path}.",
	"Agents outside a section stay in the order they joined. Put them in a section to order them.":
		"Agenter uden sektion står i den rækkefølge, de kom til. Læg dem i en sektion for at ordne dem.",
	Pinned: "Fastgjorte",
	"Drop here to pin": "Slip her for at fastgøre",
	Unassigned: "Uden sektion",
	"New section": "Ny sektion",
	"Section name": "Sektionens navn",
	"A section called {name} already exists.": "Der findes allerede en sektion, der hedder {name}.",
	Rename: "Omdøb",
	Unpin: "Frigør",
	"The pinned row is full. Unpin something first.": "Rækken med fastgjorte er fuld. Frigør noget først.",
	Pin: "Fastgør",
	"Copy conversation ID": "Kopiér samtale-id",
	"The conversation ID could not be copied.": "Samtale-id’et kunne ikke kopieres.",
	"Show in sidebar": "Vis i sidepanelet",
	Hidden: "Skjulte",
	"Hidden: {count}": "Skjulte: {count}",
	"Hide from sidebar": "Skjul fra sidepanelet",
	Delete: "Slet",
	"Delete {name}? The agent leaves the company for everyone, with its conversations and routines. This cannot be undone.":
		"Slet {name}? Agenten forlader virksomheden for alle, med sine samtaler og rutiner. Det kan ikke fortrydes.",
	"{name} could not be deleted. Hand over the projects it leads first.":
		"{name} kunne ikke slettes. Giv først de projekter, den leder, videre.",
	"{name} could not be deleted.": "{name} kunne ikke slettes.",
	"Rename section": "Omdøb sektion",
	"Delete section": "Slet sektion",
	"Delete the section {name}? Its agents and group chats move to Unassigned, for everyone in the company.":
		"Slet sektionen {name}? Dens agenter og gruppechats flyttes til Uden sektion for alle i virksomheden.",
	"Delete {name}? The group chat is removed for everyone. This cannot be undone.":
		"Slet {name}? Gruppechatten fjernes for alle. Det kan ikke fortrydes.",
	"The group chat could not be deleted.": "Gruppechatten kunne ikke slettes.",
	Sidebar: "Sidepanel",
	"{name} actions": "Handlinger for {name}",
	Section: "Sektion",
	// The Bank page (app/views/bank.ts)
	"{amount} kr": "{amount} kr.",
	Once: "Én gang",
	"Every day": "Hver dag",
	Weekdays: "Hverdage",
	Weekly: "Hver uge",
	Monthly: "Hver måned",
	"Every quarter": "Hvert kvartal",
	"Every year": "Hvert år",
	"Each payout": "Ved hver udbetaling",
	"Now and then": "Af og til",
	Overview: "Overblik",
	"Money in": "Penge ind",
	"Money out": "Penge ud",
	"The bank summary can't be read": "Bankoversigten kan ikke læses",
	"Its file in the company folder doesn't follow the bank summary format.":
		"Dens fil i virksomhedsmappen følger ikke formatet for bankoversigten.",
	"No bank yet": "Ingen bank endnu",
	"When the company's bank is connected, its saldo and what comes in and goes out show here.":
		"Når virksomhedens bank er forbundet, vises saldoen og hvad der kommer ind og går ud her.",
	"{bank} paused sharing on {date}.": "{bank} stoppede med at dele den {date}.",
	"Banks ask again every 180 days. It takes half a minute with MitID.":
		"Banker spørger igen hver 180. dag. Det tager et halvt minut med MitID.",
	"No account was shared with Qorpera.": "Ingen konto blev delt med Qorpera.",
	"The bank did not complete the sign-in. Try again.": "Banken gennemførte ikke log-ind. Prøv igen.",
	"The bank was not connected.": "Banken blev ikke forbundet.",
	"The bank is connected. Its numbers arrive here within a few minutes.":
		"Banken er forbundet. Tallene kommer her inden for få minutter.",
	"Finishing the bank connection": "Gør bankforbindelsen færdig",
	"The bank is connected": "Banken er forbundet",
	"Its saldo and what comes in and goes out show here within a few minutes.":
		"Saldo og det, der går ind og ud, vises her inden for få minutter.",
	"An owner or admin can connect the company's bank.": "En ejer eller administrator kan forbinde virksomhedens bank.",
	"Connect the bank": "Forbind banken",
	"The bank connection could not be read.": "Bankforbindelsen kunne ikke læses.",
	"Connect again": "Forbind igen",
	"Connect the company's bank": "Forbind virksomhedens bank",
	"Which bank does the company use?": "Hvilken bank bruger virksomheden?",
	"The account is in my own name, not the company's": "Kontoen står i mit eget navn, ikke virksomhedens",
	"Next, you log in at {bank}": "Nu logger du ind hos {bank}",
	"You use your MitID on the bank's own page.": "Du bruger dit MitID på bankens egen side.",
	"Qorpera never sees your login.": "Qorpera ser aldrig dit log-ind.",
	"You choose which accounts to share.": "Du vælger selv, hvilke konti der deles.",
	"Agents can read balances and payments. They can't pay.":
		"Agenterne kan læse saldo og betalinger. De kan ikke betale.",
	"Opening {bank}…": "Åbner {bank}…",
	"Go to {bank}": "Gå til {bank}",
	Saldo: "Saldo",
	Disponibel: "Disponibel",
	Reserveret: "Reserveret",
	"Put in money": "Indskyd penge",
	Range: "Periode",
	"3 months": "3 måneder",
	"1 year": "1 år",
	"{bank} · updated {when}": "{bank} · opdateret {when}",
	"Expected around {date}: {amount}": "Forventet omkring {date}: {amount}",
	"{date}: {amount}": "{date}: {amount}",
	"The saldo over time shows once the bank has shared a few days.":
		"Saldoen over tid vises, når banken har delt et par dage.",
	"The saldo over the last {range}, with what is expected ahead dotted":
		"Saldoen over det seneste {range}, med det forventede prikket",
	year: "år",
	"In and out": "Ind og ud",
	"{month} in: {amount}": "{month} ind: {amount}",
	"{month} out: {amount}": "{month} ud: {amount}",
	"Repeats every month": "Gentages hver måned",
	"Average a month": "Gennemsnit pr. måned",
	"Also coming: {name}": "Kommer også: {name}",
	"on {date}": "den {date}",
	"Where it comes from": "Hvor de kommer fra",
	"Where it goes": "Hvor de går hen",
	"Nothing this month yet.": "Intet denne måned endnu.",
	Total: "I alt",
	"Each month": "Hver måned",
	"the Co-Founder": "Co-Founderen",
	"Loan from {name}": "Lån fra {name}",
	"the owner": "ejeren",
	"Share capital, {name}": "Selskabskapital, {name}",
	"How much": "Hvor meget",
	"Amount in kroner": "Beløb i kroner",
	kr: "kr.",
	"How the money goes in": "Hvordan pengene indskydes",
	"A loan to the company": "Et lån til virksomheden",
	"You can take it back later. {agent} writes a short loan paper for the books.":
		"Du kan tage dem ud igen senere. {agent} skriver et kort gældsbrev til bogføringen.",
	"More share capital": "Mere selskabskapital",
	"It stays in the company for good, and has to be registered with the Danish Business Authority. {agent} prepares it, and you sign with MitID.":
		"Den bliver i virksomheden for altid og skal registreres hos Erhvervsstyrelsen. {agent} forbereder det, og du underskriver med MitID.",
	"Send {amount} from your own bank to the company's account, with this text on the transfer:":
		"Overfør {amount} fra din egen bank til virksomhedens konto med denne tekst på overførslen:",
	"The account number shows once the bank shares it.": "Kontonummeret vises, når banken deler det.",
	"It shows here as money in when it arrives. Tell {agent}, so the books keep it as a loan from you.":
		"Det vises her som penge ind, når det kommer. Sig det til {agent}, så bogføringen holder det som et lån fra dig.",
	"It shows here as money in when it arrives. Tell {agent}, so the registration can be prepared.":
		"Det vises her som penge ind, når det kommer. Sig det til {agent}, så registreringen kan forberedes.",
	Continue: "Fortsæt",
	"Write an amount like 50.000 or 1.250,50.": "Skriv et beløb som 50.000 eller 1.250,50.",
	"Welcome back, {name}.": "Velkommen tilbage, {name}.",
	"Pick a company.": "Vælg en virksomhed.",
	"Your companies": "Dine virksomheder",
	"{company}: {name} invited you to start it together": "{company}: {name} har inviteret dig til at starte den sammen",
	"{company}: you are invited to start it together": "{company}: du er inviteret til at starte den sammen",
	"{company}: your table, not started yet": "{company}: dit bord, ikke startet endnu",
	"{company}: you are invited as {role}": "{company}: du er inviteret som {role}",
	"Join {company} as {role}?": "Vil du deltage i {company} som {role}?",
	"Decline the invitation to {company}": "Afvis invitationen til {company}",
	"Decline the invitation to {company}?": "Vil du afvise invitationen til {company}?",
	"{name} saved you a seat at {company}.": "{name} har holdt en plads til dig ved {company}.",
	"You have a seat at {company}.": "Du har en plads ved {company}.",
	"You are invited to {company} as {role}.": "Du er inviteret til {company} som {role}.",
};
